"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotInbox = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotInbox = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M21.5 8c3.35.756 9.372.966 13.25 4.766 3.878 3.811 6.665 10.498 4.485 14.332-2.192 3.823-9.43 3.368-15.735 4.902-6.317 1.545-11.769 3.665-15.58 1.95C4.123 32.237 2.065 28.113.93 23.343c-1.146-4.77-1.27-8.762-.157-12.1 1.1-3.337 3.462-6.01 6.148-6.89 2.698-.868 4.685-.12 7.08.647 1.953.834 4.14 2.233 7.5 3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M36.665 20h-10l-3.333 5h-6.667l-3.333-5h-10m33.333 0v10a3.333 3.333 0 0 1-3.333 3.334H6.665A3.333 3.333 0 0 1 3.332 30V20m33.333 0-5.75-11.483a3.334 3.334 0 0 0-2.983-1.85H12.065a3.334 3.334 0 0 0-2.983 1.85L3.332 20"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotInbox = SpotInbox;
SpotInbox.displayName = "SpotInbox";